import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useBillToState = convertSelectorToHook(getBillToState);
